"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stockIndicatorStyles = exports.shippingFeeStyles = exports.outOfStockMessageStyles = exports.instantResultRowWrapperStyles = exports.instantResultInstructionsStyles = exports.instantResultInstructionsItemStyles = exports.deliveryMethodTagStyles = exports.additionalInfoStyles = void 0;
const instantResultRowWrapperStyles = theme => ({
  alignItems: 'center',
  borderBottom: `1px solid ${theme.palette.divider}`,
  cursor: 'pointer',
  display: 'grid',
  gridTemplateAreas: `
      'deliveryMethodTag'
      'pickupPointInfo'
      'shippingFee'
      'additionalInfo'`,
  padding: theme.spacing(3, 0),
  '&:last-child': {
    borderBottom: 0
  },
  [theme.breakpoints.up('sm')]: {
    justifyContent: 'space-between',
    gridTemplateAreas: `
      'deliveryMethodTag shippingFee'
      'pickupPointInfo shippingFee'
      'additionalInfo shippingFee'`
  }
});
exports.instantResultRowWrapperStyles = instantResultRowWrapperStyles;
const instantResultInstructionsStyles = exports.instantResultInstructionsStyles = {
  gridArea: 'pickupPointInfo',
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column'
};
const instantResultInstructionsItemStyles = isLabel => ({
  ...(isLabel && {
    fontWeight: 'bold'
  })
});
exports.instantResultInstructionsItemStyles = instantResultInstructionsItemStyles;
const deliveryMethodTagStyles = theme => ({
  gridArea: 'deliveryMethodTag',
  justifySelf: 'start',
  marginBottom: theme.spacing(2)
});
exports.deliveryMethodTagStyles = deliveryMethodTagStyles;
const shippingFeeStyles = theme => ({
  fontWeight: 'bold',
  gridArea: 'shippingFee',
  [theme.breakpoints.down('sm')]: {
    margin: theme.spacing(2, 0, 0)
  }
});
exports.shippingFeeStyles = shippingFeeStyles;
const additionalInfoStyles = theme => ({
  gridArea: 'additionalInfo',
  display: 'flex',
  alignItems: 'center',
  [theme.breakpoints.up('sm')]: {
    margin: theme.spacing(2, 0, 0)
  }
});
exports.additionalInfoStyles = additionalInfoStyles;
const stockIndicatorStyles = (isOutOfStock, theme) => ({
  width: 8,
  height: 8,
  borderRadius: '50%',
  margin: theme.spacing(0, 1, 0, 3),
  backgroundColor: theme.palette.success.main,
  ...(isOutOfStock && {
    backgroundColor: theme.palette.error.dark
  })
});
exports.stockIndicatorStyles = stockIndicatorStyles;
const outOfStockMessageStyles = theme => ({
  color: theme.palette.error.dark
});
exports.outOfStockMessageStyles = outOfStockMessageStyles;